import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { task, timeout } from 'ember-concurrency';
import { inject as iService } from '@ember/service';
import moment from 'moment-timezone';
import { beebeeAjaxGet } from 'beebee-base/lib/utility';
import getConfig from 'beebee-base/lib/get-config';

export default class RescheduleModalComponent extends Component {
  @iService session;
  @iService notify;
  @iService intl;

  @tracked dateCalendar = new Date();
  @tracked dispos_slot = null;
  @tracked selectedSlot = null;
  @tracked noDispoAvailable = false;
  @tracked selectedTimeZone = moment.tz.guess();

  get event() {
    return this.args.event;
  }

  get contactId() {
    const contacts = this.event?.contacts;
    if (!contacts || !contacts.length) return null;
    const specialist = contacts.find((c) => String(c.contact_state?.id) === '120');
    return specialist?.id || null;
  }

  get productId() {
    const products = this.event?.products;
    if (!products || !products.length) return null;
    const treatment = products.find((p) => String(p.product_state?.id) === '1');
    return treatment?.id || products[0]?.id || null;
  }

  get slotsForDate() {
    if (!this.dateCalendar || !this.dispos_slot) return [];
    const dateKey = moment(this.dateCalendar).format('YYYY-MM-DD');
    return this.dispos_slot.giorni?.[dateKey]?.slots || [];
  }

  @(task(function* (date = new Date()) {
    this.dateCalendar = date;
    document.querySelectorAll('button.ember-power-calendar-day').forEach((el) => {
      el.setAttribute('available', false);
    });

    yield timeout(250);

    const momentDate = moment(date);
    const from_date = momentDate
      .clone()
      .startOf('month')
      .tz(this.selectedTimeZone)
      .format('YYYY-MM-DDTHH:mmZ');
    const to_date = momentDate
      .clone()
      .endOf('month')
      .tz(this.selectedTimeZone)
      .format('YYYY-MM-DDTHH:mmZ');

    try {
      const dispos = yield beebeeAjaxGet(
        `${getConfig(this).APP.urlApi}/dispos`,
        this.session.token,
        {
          contact_id: this.contactId,
          product_id: this.productId,
          from_date,
          to_date,
        }
      );

      let noDispoAvailable = true;
      if (Array.isArray(dispos.giorni_array)) {
        noDispoAvailable = false;
        dispos.giorni_array.forEach((d) => {
          document
            .querySelectorAll(`button.ember-power-calendar-day[data-date='${d}']`)
            .forEach((el) => {
              el.setAttribute('available', true);
            });
        });
      }

      this.noDispoAvailable = noDispoAvailable;
      this.dispos_slot = dispos;
    } catch (e) {
      // silent
    }
  }).restartable())
  loadSlotsTask;

  @action
  initCalendar() {
    this.loadSlotsTask.perform(new Date());
  }

  @action
  selectDate(calendar) {
    this.dateCalendar = calendar.date;
    this.selectedSlot = null;
  }

  @action
  selectSlot(slot) {
    this.selectedSlot = slot;
  }

  @action
  changeMonth(calendar) {
    this.loadSlotsTask.perform(calendar.date);
  }

  @action
  confirmReschedule() {
    if (!this.selectedSlot) return;
    this.args.onConfirm(this.event, this.selectedSlot);
  }

  @action
  close() {
    this.args.onClose();
  }
}
